/*
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved.
* Distributed under the TruVideo proprietary license.
*/
let loadPromise = null;

const loadLiveSessionSdk = (host) => {
  if (window.TruVideoLiveSession) {
    return Promise.resolve(window.TruVideoLiveSession);
  }

  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `${host}/sdk/connector/live-session-sdk.js`;
    script.async = true;
    script.onload = () => {
      if (window.TruVideoLiveSession) {
        resolve(window.TruVideoLiveSession);
      } else {
        reject(new Error('Live Session SDK loaded but TruVideoLiveSession is undefined'));
      }
    };
    script.onerror = () => {
      loadPromise = null;
      reject(new Error('Failed to load Live Session SDK'));
    };
    document.head.appendChild(script);
  });

  return loadPromise;
};

export default loadLiveSessionSdk;
